import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { XCircle } from 'lucide-react';
import { buildMarketingUrl } from '@/lib/workspace';
import type { Account } from '@/types/icrop';

interface WorkspaceUnavailablePageProps {
  account: Account;
  reason: 'deleted' | 'cancelled';
}

export function WorkspaceUnavailablePage({ account, reason }: WorkspaceUnavailablePageProps) {
  const message =
    reason === 'deleted'
      ? `${account.name} has been removed and is no longer available.`
      : `The subscription for ${account.name} has been cancelled.`;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <XCircle className="h-12 w-12 text-destructive" />
          </div>
          <CardTitle className="text-2xl">Workspace unavailable</CardTitle>
          <CardDescription>{message}</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild variant="outline">
            <a href={buildMarketingUrl()}>Back to iCrop.net</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
